import React, { createContext, useContext, useState } from 'react'

interface RefreshTypes {
    refresh: {
        Notification: boolean
    },
    toggleRefresh: () => void
}
const RefreshContext = createContext<RefreshTypes | null>(null)

export const RefreshProvider = ({ children }: { children: React.ReactNode }) => {
    const [refresh, setRefresh] = useState<{
        Notification: boolean
    }>({
        Notification: false
    })
    const toggleRefresh = () => {
        setRefresh((prev) => ({ ...refresh, Notification: !prev.Notification }))
    }
    return (
        <RefreshContext.Provider value={{ refresh, toggleRefresh }}>
            {children}
        </RefreshContext.Provider>
    )
}

export const useRefresh = () => {
    const context = useContext(RefreshContext)
    if (!context) throw new Error('useRefresh must be used within a RefreshProvider')
    return context
}